import * as React from 'react';
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import { Box, Divider, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
export default function ViewMorePopover({
    children, // Content inside the Popover
    className = "",
}) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handlePopoverOpen = (event) => {
        event.stopPropagation();
        console.log("clicked", event.currentTarget);

        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    React.useEffect(() => {
        console.log("anchorEl", anchorEl);
    }, [anchorEl])

    const open = Boolean(anchorEl);
    const id = open ? 'hover-popover' : undefined;
    console.log("fdgdfg", children);

    console.log("open", open);
    return (
        <div
        >

            <Typography
                aria-owns={open ? id : undefined}
                aria-haspopup="true"
                // className={` ${className}`}
                onClick={handlePopoverOpen}
                color='primary'
                variant="body2"
                className="d-flex align-items-center font-weight-semibold"

            >
                View More <KeyboardArrowDownIcon />
            </Typography>


            {children &&

                <Popover
                    className='popover-wrapper'
                    id={id}

                    open={open}
                    anchorEl={anchorEl}
                    onClose={handlePopoverClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <Box
                        className="popover-wrapper p-3 position-relative h-100"

                    >

                        <Typography variant="body2" className='font-weight-bold' color='primary' gutterBottom>
                            More Details
                        </Typography>
                        <Divider />
                        <div className='view-more-scroller'>
                            <Typography className='mt-2 mb-2' variant="body1" gutterBottom>
                                {children}
                            </Typography>

                        </div>
                        <Box className="d-flex" justifyContent={"flex-end"}>
                            <Button
                                variant="contained"
                                className="d-flex text-center align-items-center"
                                size='small'
                                onClick={handlePopoverClose}

                            >
                                Done
                            </Button>
                        </Box>
                    </Box>


                </Popover>

            }
        </div>
    );
}
